import Box13GarageLogo from "../assets/media/box13-garage-logo-black.png";
import GlobalVendasLogo from "../assets/media/logo-global-vendas.png";
import JrFigurinhasLogo from "../assets/media/logo-jr.jpeg";
import JonataCanelaLogo from "../assets/media/logo-jonata.png";

export const PROJECT_CASES = [
    {
        name: "Global Vendas",
        setor: "Corretora de seguros",
        local: "Cuiabá, MT",
        category: "Automação de processos",
        rotaSlug: "processo-manual",
        icon: "sync_problem",
        logo: GlobalVendasLogo,
        logoAlt: "Logo da Global Vendas",
        clientLocation: "Cuiabá, MT, Brasil",
        headline: "A renovação de apólice deixou de depender da memória do time",
        problema: "O controle de vencimentos vivia numa planilha alimentada à mão. Quem lembrava, cobrava; quem não lembrava, perdia a renovação. Além disso, duas ferramentas de gestão faziam a mesma coisa em setores diferentes, e ninguém sabia o custo mensal somado.",
        deliverables: [
            "Rotina automática de aviso de vencimento por WhatsApp e e-mail",
            "Painel único de apólices, com status por corretor",
            "Inventário de ferramentas e consolidação de licenças"
        ],
        metric: "−4 h/semana",
        metricLabel: "de tarefas manuais de cobrança, com 3 de 8 assinaturas eliminadas",
        quote: "Paramos de perder tempo com cobranças.",
        author: "Sócio-diretor · Global Vendas"
    },
    {
        name: "Box13 Garage",
        setor: "Detalhe automotivo",
        local: "Porto, Portugal",
        category: "Software sob medida",
        rotaSlug: "sistema-sob-medida",
        icon: "grid_view",
        logo: Box13GarageLogo,
        logoAlt: "Logo da Box13 Garage",
        clientLocation: "Porto, Portugal",
        headline: "Orçamento fechado no balcão, com o cliente ainda na loja",
        problema: "Cada orçamento levava cerca de 40 minutos: conferir tabela de serviço, calcular tempo de box, somar produto e digitar tudo à mão. Nenhum sistema de prateleira aceitava a combinação de serviço, veículo e nível de acabamento que a operação usa.",
        deliverables: [
            "Sistema próprio de orçamento por serviço, veículo e acabamento",
            "Agenda de box integrada ao orçamento aprovado",
            "Histórico por cliente e por veículo",
            "Primeira versão em uso antes do projeto terminar"
        ],
        metric: "orçamento em 5 min",
        metricLabel: "no lugar de 40 minutos por proposta",
        quote: "Fecho orçamento com o cliente ainda no balcão.",
        author: "Proprietário · Box13 Garage"
    },
    {
        name: "Jr Figurinhas",
        setor: "Colecionáveis",
        local: "Natal, RN",
        category: "Sites e landing pages",
        rotaSlug: "site-que-nao-converte",
        icon: "language",
        logo: JrFigurinhasLogo,
        logoAlt: "Logo da Jr Figurinhas",
        clientLocation: "Natal, RN, Brasil",
        headline: "A página passou a explicar o negócio antes da primeira mensagem",
        problema: "O site antigo tinha visita, mas quase nenhum contato: quem entrava não entendia o que era vendido, para quem, nem como comprar. As dúvidas chegavam todas pelo WhatsApp, uma por uma, sempre as mesmas.",
        deliverables: [
            "Mensagem e estrutura definidas antes do visual",
            "Página rápida em celular e indexável",
            "Contato por WhatsApp com origem medida"
        ],
        metric: "+3× contatos",
        metricLabel: "no primeiro trimestre após a nova página",
        quote: "O pessoal chega sabendo o que a gente faz.",
        author: "Proprietário · Junior Figurinhas"
    },
    {
        name: "Jonatã Canela",
        setor: "Consultoria gastronômica",
        local: "Natal, RN",
        category: "Sites e landing pages",
        rotaSlug: "site-que-nao-converte",
        icon: "language",
        logo: JonataCanelaLogo,
        logoAlt: "Logo de Jonatã Canela",
        clientLocation: "Natal, RN, Brasil",
        headline: "Do Instagram a um blog que já fechou anunciante antes de ir ao ar",
        problema: "Chef executivo, influenciador e consultor de restaurantes, Jonatã concentrava toda a presença online no Instagram — sem site, sem blog e sem um canal de e-mail profissional para negociar parcerias.",
        deliverables: [
            "Site institucional com posicionamento de chef e consultor",
            "Blog próprio para publicar conteúdo autoral e receber anunciantes",
            "Configuração e manutenção do serviço de e-mail profissional"
        ],
        metric: "2 anunciantes",
        metricLabel: "fechados direto no blog antes mesmo do projeto ser concluído",
        quote: "Antes eu só existia no Instagram. Fechei os dois primeiros anunciantes no blog antes de ele nem estar pronto.",
        author: "Chef executivo e consultor · Jonatã Canela"
    }
];

export default PROJECT_CASES;
